"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHORT_DATE_FORMAT = exports.USER_FULL_NUMBER_DATE_FORMAT = exports.USER_FULL_TEXT_DATE_FORMAT = exports.USER_SHORT_DATE_FORMAT = void 0;
var USER_SHORT_DATE_FORMAT = 'ddd, MMMM DD, YYYY';
exports.USER_SHORT_DATE_FORMAT = USER_SHORT_DATE_FORMAT;
var USER_FULL_TEXT_DATE_FORMAT = 'dddd, MMMM DD, YYYY @ h:mm A';
exports.USER_FULL_TEXT_DATE_FORMAT = USER_FULL_TEXT_DATE_FORMAT;
var USER_FULL_NUMBER_DATE_FORMAT = 'MM/DD/YYYY @ h:mm A';
exports.USER_FULL_NUMBER_DATE_FORMAT = USER_FULL_NUMBER_DATE_FORMAT;
var SHORT_DATE_FORMAT = 'MM/DD/YYYY';
exports.SHORT_DATE_FORMAT = SHORT_DATE_FORMAT;